import React, { createContext, useContext } from 'react'

export const ModalContainerContext = createContext<Element | null>(null)

export const useModalContainer = () => useContext(ModalContainerContext)
